import { ethers, Contract } from 'ethers'
import { StaticJsonRpcProvider } from '@ethersproject/providers'

import ERC20ABI from './abi/erc20.json'

export function getPoolLiquidityContract(
	address: string,
	provider: StaticJsonRpcProvider
): Contract {
	return new ethers.Contract(address, ERC20ABI, provider)
}
